/* unhandledErrorCard-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "./unhandledErrorCard-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import WarningIcon from '@atlaskit/icon/core/migration/status-warning--editor-warning';
import { N20, N800, Y500 } from '@atlaskit/theme/colors';
import { defaultImageCardDimensions } from '../../../utils';
import { ContentLoadingErrorMessage } from './contentLoadingErrorMessage';
var isPercentage = function isPercentage(value) {
  return /^\d+(\.\d+)?%$/.test(value);
};
var shouldShowText = function shouldShowText(_ref) {
  var width = _ref.width,
    height = _ref.height;
  if (isPercentage(width) || isPercentage(height)) {
    return false;
  }
  return parseInt(width, 10) >= 240 && parseInt(height, 10) >= 90;
};
var normalizeDimension = function normalizeDimension(value, defaultValue) {
  var sValue = value.toString();
  return isPercentage(sValue) ? sValue : isNaN(parseInt(sValue, 10)) ? defaultValue + 'px' : parseInt(sValue, 10) + 'px';
};
var getConvertedDimension = function getConvertedDimension(dimensions) {
  var _dimensions$width = dimensions.width,
    width = _dimensions$width === void 0 ? defaultImageCardDimensions.width : _dimensions$width,
    _dimensions$height = dimensions.height,
    height = _dimensions$height === void 0 ? defaultImageCardDimensions.height : _dimensions$height;
  return {
    width: normalizeDimension(width, defaultImageCardDimensions.width),
    height: normalizeDimension(height, defaultImageCardDimensions.height)
  };
};
var wrapperStyle = null;
export var UnhandledErrorCard = /*#__PURE__*/function (_Component) {
  function UnhandledErrorCard() {
    _classCallCheck(this, UnhandledErrorCard);
    return _callSuper(this, UnhandledErrorCard, arguments);
  }
  _inherits(UnhandledErrorCard, _Component);
  return _createClass(UnhandledErrorCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$dimension = _this$props.dimensions,
        dimensions = _this$props$dimension === void 0 ? defaultImageCardDimensions : _this$props$dimension,
        onClick = _this$props.onClick;
      var convertedDimensions = getConvertedDimension(dimensions);
      var hideText = !shouldShowText(getConvertedDimension(dimensions));
      return /*#__PURE__*/React.createElement("div", {
        onClick: onClick,
        "data-testid": "unhandled-error-card",
        className: ax(["_2rkofajl _1e0c1txw _4cvr1h6o _1bah1h6o _bfhklslw _syaz1dfj _c71l1osq _p12f1osq _2lx21bp4 _1i7v2smr _31ku1h6o"]),
        style: _objectSpread(_objectSpread({}, convertedDimensions), {}, {
          "--_1jkcdu5": ix("var(--ds-background-neutral, ".concat(N20, ")")),
          "--_i2cu7k": ix("var(--ds-text-subtle, ".concat(N800, ")"))
        })
      }, /*#__PURE__*/React.createElement(WarningIcon, {
        label: "Error",
        color: "var(--ds-icon-warning, ".concat(Y500, ")"),
        LEGACY_size: "medium",
        spacing: "spacious"
      }), /*#__PURE__*/React.createElement(ContentLoadingErrorMessage, {
        isHidden: hideText
      }));
    }
  }]);
}(Component);